import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

export const DotVertical = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
            <g id="dot-vertical">
                <g>
                    <path d="M12.4 2C11.0745 2 10 3.07452 10 4.4C10 5.72548 11.0745 6.8 12.4 6.8C13.7255 6.8 14.8 5.72548 14.8 4.4C14.8 3.07452 13.7255 2 12.4 2Z" />
                    <path d="M12.4 9.2C11.0745 9.2 10 10.2745 10 11.6C10 12.9255 11.0745 14 12.4 14C13.7255 14 14.8 12.9255 14.8 11.6C14.8 10.2745 13.7255 9.2 12.4 9.2Z" />
                    <path d="M12.4 16.4C11.0745 16.4 10 17.4745 10 18.8C10 20.1255 11.0745 21.2 12.4 21.2C13.7255 21.2 14.8 20.1255 14.8 18.8C14.8 17.4745 13.7255 16.4 12.4 16.4Z" />
                </g>
            </g>
        </SvgIcon>
    );
};
